import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { LatLongIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';
import { HoveredCopyButton } from '../../HoveredButtons';
import { handleSetIsCopiedTimer } from '../../HoveredButtons/helpers';
import { CopyableBox, IconWrapper } from './DataCardLocation.styles';
import { trackCopyAlertLocation } from './alertLocationTrackings';

interface PortalState {
  incidents: { selectedAlertID: string };
  sinatra: { irp: { irpVersion: string } };
}

interface LatLongInterface {
  longitude: number;
  latitude: number;
}

const LatLong = ({ longitude, latitude }: LatLongInterface) => {
  const [isCopied, setIsCopied] = useState(false);
  const selectedAlertID = useSelector(
    (state: PortalState) => state.incidents.selectedAlertID,
  );
  const irpVersion = useSelector(
    (state: PortalState) => state.sinatra.irp.irpVersion,
  );

  const onClick = () => {
    trackCopyAlertLocation(selectedAlertID, irpVersion);
    handleSetIsCopiedTimer(setIsCopied);
  };

  const latLong = `${latitude.toFixed(5)}, ${longitude.toFixed(5)}`;

  return (
    <CopyableBox isCopied={isCopied}>
      <IconWrapper mr={2}>
        <LatLongIcon />
      </IconWrapper>
      <Box horizontal>
        <Text size="normal" color="secondaryText">
          Lat/Long:&nbsp;
        </Text>
        <Text size="normal" color="primaryText">
          {latLong}
        </Text>
      </Box>
      <HoveredCopyButton
        handleClick={onClick}
        copyableText={`${latitude}, ${longitude}`}
      />
    </CopyableBox>
  );
};

export default LatLong;
